import { ExtractionResult, ExtractionSelector } from '../../interfaces/functions.interface';
import { IPadConfig, IPadResult } from '../../interfaces';
import { Observable } from 'rxjs';
import { QuoteSideTypeEnum, SymbolTypes } from '@fnx/fx-pad';

export interface IPadConfigService {
    configObservable<S extends ExtractionSelector<IPadResult>>(prop: S): Observable<ExtractionResult<IPadResult, S>>;
    placeOrder(side: QuoteSideTypeEnum): void;
    start(id: string): void;
    update(config: IPadConfig): void;
    toggleFeed(state: boolean): void
    stop(): void;
}

export type StateMutation<T> = (acc: T, changeset: Partial<T>) => Partial<T>;

export const SPOT_PRICE_TYPE: Array<SymbolTypes> = [ 'spot', 'pending' ];
export const FORWARD_TYPE: Array<SymbolTypes> = [ 'forward', 'swap' ];
